var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SeverityIcon } from "../Icons/SeverityIcons";
import { Alert as AntDAlert } from "antd";
import { useMemo } from "react";
const iconByType = {
    error: _jsx(SeverityIcon, { alt: "error", size: 24, severity: "error" }),
    info: _jsx(SeverityIcon, { alt: "info", size: 24, severity: "information" }),
    success: _jsx(SeverityIcon, { alt: "success", size: 24, severity: "success" }),
    warning: _jsx(SeverityIcon, { alt: "warning", size: 24, severity: "warning" })
};
const Alert = (_a) => {
    var { type } = _a, props = __rest(_a, ["type"]);
    const customProps = useMemo(() => {
        if (!type) {
            return undefined;
        }
        const additionalProps = {
            icon: iconByType[type]
        };
        return additionalProps;
    }, [type]);
    return _jsx(AntDAlert, Object.assign({}, customProps, props, { type: type }));
};
export default Alert;
